import update from "immutability-helper";
import { findIndex as _findIndex } from "lodash-es";
import { NO_NAME_PLACEHOLDER } from "../components/HumanListRow";

import {
  COMMIT_HUMAN,
  DELETE_HUMAN,
  REVERT_HUMAN,
  UPDATE_HUMAN,
} from "../actions/humans";
import { FETCH_UPDATES_SUCCESS, SET_PENDING, SET_SAVED } from "../actions/sync";
import {
  setPendingFlag,
  makeObjectsSaved,
  updateFromFetchUpdates,
} from "../utils";

export default function humans(state = [], action) {
  switch (action.type) {
    case COMMIT_HUMAN: {
      let humanExist = state.find((human) => human.id === action.human.id);
      if (humanExist) return state;

      return [
        {
          id: action.human.id,
          name: action.human.name,
          createdAt: new Date().toISOString(),
          modifiedAt: new Date().toISOString(),
          pending: false,
          modified: true,
        },
        ...state,
      ];
    }

    case FETCH_UPDATES_SUCCESS: {
      return updateFromFetchUpdates(state, action.payload.data.humans);
    }

    case UPDATE_HUMAN: {
      const humanIndex = _findIndex(state, { id: action.humanId });
      const human = state[humanIndex];

      // Check if updating item is name
      const isName = Object.prototype.hasOwnProperty.call(action.obj, "name");

      // If human dont have name and updating item is not `name`
      // Then make name into NO_NAME_PLACEHOLDER
      if (!human.name && !isName) {
        action.obj.name = NO_NAME_PLACEHOLDER;
      }

      if (action.obj.modified) {
        action.obj.modifiedAt = new Date().toISOString();
      }

      return update(state, { [humanIndex]: { $merge: action.obj } });
    }

    case SET_PENDING: {
      return setPendingFlag(state, action.data.human, action.pending);
    }

    case SET_SAVED: {
      return makeObjectsSaved(state, action.data.human);
    }

    case DELETE_HUMAN: {
      const humanIndex = _findIndex(state, { id: action.id });
      return update(state, { $splice: [[humanIndex, 1]] });
    }

    case REVERT_HUMAN: {
      const humanIndex = _findIndex(state, { id: action.humanId });
      const human = state[humanIndex];

      if (!human.conflict) {
        return state;
      }

      return update(state, { [humanIndex]: { $set: human.conflict } });
    }

    default:
      return state;
  }
}
